/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Links_Docs_LabelInputs */

const en_welcome_links_docs_label = /** @type {(inputs: Welcome_Links_Docs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const fr_welcome_links_docs_label = /** @type {(inputs: Welcome_Links_Docs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const ms_sg2_welcome_links_docs_label = /** @type {(inputs: Welcome_Links_Docs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi`)
};

/**
* | output |
* | --- |
* | "Documentation" |
*
* @param {Welcome_Links_Docs_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_links_docs_label = /** @type {((inputs?: Welcome_Links_Docs_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Links_Docs_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_links_docs_label(inputs)
	if (locale === "fr") return fr_welcome_links_docs_label(inputs)
	return ms_sg2_welcome_links_docs_label(inputs)
});